import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("gpm_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Public
export const fetchCars = (params = {}) => client.get("/cars", { params }).then((r) => r.data);
export const fetchCar = (slug) => client.get(`/cars/${slug}`).then((r) => r.data);
export const createLead = (data) => client.post("/leads", data).then((r) => r.data);
export const fetchContent = (key) => client.get(`/content/${key}`).then((r) => r.data);

// Auth
export const login = (username, password) =>
  client.post("/auth/login", { username, password }).then((r) => r.data);

// Admin — cars
export const adminCreateCar = (data) => client.post("/cars", data).then((r) => r.data);
export const adminListCars = (params = {}) => client.get("/admin/cars", { params }).then((r) => r.data);
export const adminUpdateCar = (id, data) => client.put(`/cars/${id}`, data).then((r) => r.data);
export const adminDeleteCar = (id) => client.delete(`/cars/${id}`).then((r) => r.data);
export const uploadImage = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return client.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
};

// Admin — leads
export const adminFetchLeads = (params = {}) => client.get("/leads", { params }).then((r) => r.data);
export const adminLeadStats = () => client.get("/leads/stats").then((r) => r.data);
export const adminEmailStatus = () => client.get("/email/status").then((r) => r.data);
export const adminMarketingOverview = () => client.get("/marketing/overview").then((r) => r.data);
export const adminUpdateContent = (key, data) => client.put(`/content/${key}`, data).then((r) => r.data);
export const adminResetContent = (key) => client.post(`/content/${key}/reset`).then((r) => r.data);
export const adminSendTestEmail = () => client.post("/email/test").then((r) => r.data);
export const adminUpdateLead = (id, data) => client.patch(`/leads/${id}`, data).then((r) => r.data);
export const adminDeleteLead = (id) => client.delete(`/leads/${id}`).then((r) => r.data);

// Admin — social (Meta posts & ads)
export const socialConnection = () => client.get("/social/connection").then((r) => r.data);
export const updateSocialConnection = (data) => client.put("/social/connection", data).then((r) => r.data);
export const metaStatus = () => client.get("/social/meta/status").then((r) => r.data);
export const metaDisconnect = () => client.post("/social/meta/disconnect").then((r) => r.data);
export const metaLoginUrl = () => `${BACKEND_URL}/api/social/meta/login`;
export const socialStats = () => client.get("/social/stats").then((r) => r.data);
export const listSocialPosts = () => client.get("/social/posts").then((r) => r.data);
export const createSocialPost = (data) => client.post("/social/posts", data).then((r) => r.data);
export const updateSocialPost = (id, data) => client.patch(`/social/posts/${id}`, data).then((r) => r.data);
export const publishSocialPost = (id) => client.post(`/social/posts/${id}/publish`).then((r) => r.data);
export const deleteSocialPost = (id) => client.delete(`/social/posts/${id}`).then((r) => r.data);
export const listSocialAds = () => client.get("/social/ads").then((r) => r.data);
export const createSocialAd = (data) => client.post("/social/ads", data).then((r) => r.data);
export const updateSocialAd = (id, data) => client.patch(`/social/ads/${id}`, data).then((r) => r.data);
export const deleteSocialAd = (id) => client.delete(`/social/ads/${id}`).then((r) => r.data);

export const isAuthed = () => !!localStorage.getItem("gpm_token");
export const setToken = (t) => localStorage.setItem("gpm_token", t);
export const clearToken = () => localStorage.removeItem("gpm_token");

export default client;
